// extracted by mini-css-extract-plugin
export var container = "_kh-0";
export var dotAnimation = "_kh-2";
export var dotsLoading = "_kh-1";